import type { SplitExperimentProps, SplitProps } from './types';

const splitExperiment = ({ featureName, treatment }: SplitExperimentProps): SplitExperimentProps => ({
  featureName: String(featureName),
  treatment: String(treatment),
});

export const getSplitState = ({ experiments = {}, featureNames = [] }: Partial<SplitProps> = {}): SplitProps => ({
  experiments: Object.keys(experiments).reduce(
    (acc: Record<string, SplitExperimentProps>, cV: string) => {
      acc[cV] = splitExperiment(experiments[cV]);

      return acc;
    },
    {} as Record<string, SplitExperimentProps>,
  ),
  featureNames: featureNames.map((featureName) => featureName),
});
